const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAstrapIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 60.3134,
    height: 52.605,
    viewBox: "0 0 60.3134 52.605",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 8",
    d: "M38.2432 7.94526L34.0433 3.74543C31.9748 1.67688 28.621 1.67689 26.5525 3.74543L22.3526 7.94526",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.76561
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 21",
    y1: -0.882806,
    x2: 15.8905,
    y2: -0.882806,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 30.7393 1.76562)",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.76561
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 8_2",
    d: "M45.4874 48.6322L51.2244 47.095C54.0501 46.3378 55.727 43.4334 54.9699 40.6077L53.4326 34.8706",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.76561
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 21_2",
    y1: -0.882806,
    x2: 15.8905,
    y2: -0.882806,
    transform: "matrix(-0.866025 -0.5 -0.5 0.866025 54.5919 45.2236)",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.76561
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 8_3",
    d: "M14.8263 48.6322L9.0892 47.095C6.26352 46.3379 4.58664 43.4334 5.34377 40.6077L6.88102 34.8706",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.76561
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 21_3",
    x1: 5.28039,
    y1: 44.459,
    x2: 19.042,
    y2: 36.5138,
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.76561
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 13",
    cx: 6.17965,
    cy: 6.17965,
    r: 6.17965,
    transform: "matrix(-1 0 0 1 36.4775 23.8358)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstrapIcon);
export default __webpack_public_path__ + "static/media/astrap-icon.61bf787e352cd37d52d0f060bd4825a1.svg";
export { ForwardRef as ReactComponent };